module.exports = __webpack_public_path__ + "volunteer_bg.png";